import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";

export default function PaymentReturnPage() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const sessionId = sp.get("session_id");
  const bookingId = sp.get("booking_id");

  useEffect(() => {
    // If opened in a new tab, try to notify the opener and close.
    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage({ type: "mc:payment_return", session_id: sessionId, booking_id: bookingId }, "*");
        setTimeout(() => window.close(), 300);
        return;
      }
    } catch {}
    // Otherwise route into the booking detail.
    if (bookingId) nav(`/bookings/${bookingId}`, { replace: true });
    else nav("/bookings", { replace: true });
  }, [sessionId, bookingId, nav]);

  return (
    <div className="min-h-screen grid place-items-center px-4">
      <Card className="p-8 max-w-md text-center">
        <div className="text-lg font-semibold">Thanks — finalising your booking…</div>
        <p className="text-sm text-muted-foreground mt-2">You can close this tab if it doesn't close automatically.</p>
      </Card>
    </div>
  );
}
